import TopNav from "lib/components/layout/TopNav";
import { builderHomePagePath, useAppRouterParams } from "lib/routeHelpers";
import type { ProductNameProps } from "ui/components/ProductName";
import ProductName from "ui/components/ProductName";
import styles from "./BuilderPortalTopNav.module.scss";

type BuilderPortalTopNavProps = Partial<ProductNameProps>;

export default function BuilderPortalTopNav(props: BuilderPortalTopNavProps = {}) {
  const { isReady, builderId } = useAppRouterParams();

  if (!isReady || !builderId) {
    return null;
  }

  return <ReadyBuilderPortalTopNav builderId={builderId} {...props} />;
}

function ReadyBuilderPortalTopNav({
  builderId,
  productName = "Higharc",
  ...props
}: BuilderPortalTopNavProps & { builderId: string }) {
  const logoPath = builderHomePagePath(builderId);

  return (
    <TopNav
      logoPath={logoPath}
      logoToShow={<ProductName title="Higharc Dashboard" productName={productName} {...props} />}
      className={styles.wrapper}
    />
  );
}
